<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-inventory"></i> Stock
      </Tab>
      <Tab tabid="tab-2">
        <i class="far fa-archive"></i> Archived
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable :columns="columnList" :url="dataURL" :filterOptions="filterOptions" :displayTools="true" @rowClick="stockClicked" :displayExportTools="true" exportTitle="Stock">
          <template v-slot:title>
            <h3>Stock List</h3>
          </template>
          <template v-slot:tools>
            <LinkButton type="new" href="/inventory/stock/new" v-if="userHasCreatePermission(PermissionTypes.InventoryPermissionTypes.stock)" sizeClass="btn"> New Stock</LinkButton>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkStock :name="row.data.code" :id="row.data.id" :newTab="false" />
              </td>
              <td class="table-data-nav-link">
                <LinkStock :name="row.data.name" :id="row.data.id" :newTab="false" />
              </td>
              <td>
                <span :class="['label', `label-stock-${row.data.type}`]">{{row.data.type | formatLookupName(InventoryStockTypeLookup)}}</span>
              </td>
              <td>
                <LabelBadge class="label-inventory-handcut mr-2" v-if="row.data.isHandCut">Hand Cut</LabelBadge>
                <LabelBadge class="label-inventory-usingFaces mr-2" v-if="row.data.isStockUsingFaces">Two Sided</LabelBadge>
                <LabelBadge class="label-inventory-usingGrain mr-2" v-if="row.data.isStockUsingGrain">Grain Direction</LabelBadge>
              </td>
              <td>
                {{formatLookupName(row.data.uomType, UOMTypeLookup)}}
              </td>
              <td v-html="displayStockCategoryTree(row.data.categoryTree)" />
            </tr>
          </template>
        </DataTable>


      </TabPage>

      <TabPage tabid="tab-2">
        <DataTable :columns="columnList" :url="archivedDataURL" :filterOptions="filterOptions" :displayTools="true" @rowClick="stockClicked" :displayExportTools="true" exportTitle="Archived Stock">
          <template v-slot:title>
            <h3>Archived Stock List</h3>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkStock :name="row.data.code" :id="row.data.id" :newTab="false" />
              </td>
              <td class="table-data-nav-link">
                <LinkStock :name="row.data.name" :id="row.data.id" :newTab="false" />
              </td>
              <td>
                <span :class="['label', `label-stock-${row.data.type}`]">{{row.data.type | formatLookupName(InventoryStockTypeLookup)}}</span>
              </td>
              <td>
                <LabelBadge class="label-inventory-handcut mr-2" v-if="row.data.isHandCut">Hand Cut</LabelBadge>
                <LabelBadge class="label-inventory-usingFaces mr-2" v-if="row.data.isStockUsingFaces">Two Sided</LabelBadge>
                <LabelBadge class="label-inventory-usingGrain mr-2" v-if="row.data.isStockUsingGrain">Grain Direction</LabelBadge>
              </td>
              <td>
                {{formatLookupName(row.data.uomType, UOMTypeLookup)}}
              </td>
              <td v-html="displayStockCategoryTree(row.data.categoryTree)" />
            </tr>
          </template>
        </DataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"

import { InventoryStockTypes, InventoryStockTypeLookup, UOMTypeLookup } from '@/store/types'

export default {
  name: "StockList",
  components: {
    TabbedBox,
    Tab,
    TabPage
  },
  props: {
    filterType: String
  },
  created() {
    this.InventoryStockTypeLookup = InventoryStockTypeLookup
    this.UOMTypeLookup = UOMTypeLookup
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
      }
      return '/inventory/stock?' + $.param(params)
    },
    archivedDataURL() {
      var params = {
        isActive: 0
      }
      return 'inventory/stock?' + $.param(params)
    }
  },
  data: () => {
    return {
      filterOptions: [
        {
          field: 'type',
          name: 'Stock Type',
          options: [
            { name: 'Glass', value: 'glass', class: 'label-stock-glass' },
            { name: 'Glass Service', value: 'glassService', class: 'label-stock-glassService' },
            { name: 'Assembly', value: 'assembly', class: 'label-stock-assembly' },
            { name: 'Template', value: 'template', class: 'label-stock-template' },
            { name: 'General', value: 'general', class: 'label-stock-general' },
          ]
        },
        {
          name: 'Info',
          options: [
            { name: 'Hand Cut', value: 'isHandCut', class: 'label-inventory-handcut' },
            { name: 'Two Sided', value: 'isStockUsingFaces', class: 'label-inventory-usingFaces' },
            { name: 'Grain Direction', value: 'isStockUsingGrain', class: 'label-inventory-usingGrain' }
          ]
        }
      ],
      breadcrumbs: [
        { title: 'Stock', link: '/inventory/stock'}
      ],
      columnList: [
        {
          title: "Code",
          data: "code",
          width: '7%',
        },
        {
          title: "Name",
          data: "name",
          width: '35%',
        },
        {
          title: "Type",
          data: "type",
          width: '8%',
        },
        {
          title: "Info",
          data: "info",
          width: '10%',
          sortable: false
        },
        {
          title: "Unit of Measure",
          data: "uomType",
          width: '10%',
          sortable: true
        },
        {
          title: "Category",
          data: "stockCategory.name",
          sortable: false,
          width: '30%',
        },
      ]
    }
  },
  methods: {
    stockClicked(rowId) {
      this.$router.push(`/inventory/stock/${rowId}`)
    },
    displayStockCategoryTree(categoryTree) {
      if(categoryTree == null)
        return ''

      return categoryTree.map(cat => cat.name).join(' <i class="fas fa-caret-right"></i> ')     
    }
    
  }
};
</script>
